import { render, staticRenderFns } from "./mainActions.vue?vue&type=template&id=ea1244a6&scoped=true&"
import script from "./mainActions.vue?vue&type=script&lang=js&"
export * from "./mainActions.vue?vue&type=script&lang=js&"
import style0 from "./mainActions.vue?vue&type=style&index=0&id=ea1244a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1244a6",
  null
  
)

export default component.exports